import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

export interface LoadConfirmationUserDetails {
  userId: string
  name: string
  address: string
  issuedBy: string
  dispatchEmail: string
  phone: string
  cell: string
  afterHoursPhone: string
  invoicePodContactName: string
  invoicePodEmail: string
  invoicePodPhone: string
  note: string
}

export const loadConfirmationApi = createApi({
  reducerPath: 'loadConfirmationApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  tagTypes: ['LoadConfirmationDetails'],
  endpoints: (builder) => ({
    getLoadConfirmationDetails: builder.query<
      LoadConfirmationUserDetails,
      { userId: string }
    >({
      query: ({ userId }) => ({
        url: `oapi/v1/users/${userId}/load-confirmation-details`,
      }),
      providesTags: (_result, _error, { userId }) => [
        { type: 'LoadConfirmationDetails', id: userId },
      ],
    }),

    updateLoadConfirmationDetails: builder.mutation<
      LoadConfirmationUserDetails,
      { userId: string; body: Partial<LoadConfirmationUserDetails> }
    >({
      query: ({ userId, body }) => ({
        url: `oapi/v1/users/${userId}/load-confirmation-details`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, { userId }) => [
        { type: 'LoadConfirmationDetails', id: userId },
      ],
    }),

    sendCarrierLoadConfirmationEmail: builder.mutation<
      { message: string },
      {
        userId: string
        recipient: string
        subject: string
        message: string
        s3Urls: string[]
      }
    >({
      query: (body) => ({
        url: 'oapi/v1/load-confirmation/send-email',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useGetLoadConfirmationDetailsQuery,
  useUpdateLoadConfirmationDetailsMutation,
  useSendCarrierLoadConfirmationEmailMutation,
} = loadConfirmationApi
